"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckoutDeliveryContext = exports.CheckoutDeliveryProvider = void 0;
var _react = require("react");
/** This can be extended by specific types for your Online properties. */

const checkoutDeliveryContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const CheckoutDeliveryProvider = exports.CheckoutDeliveryProvider = checkoutDeliveryContext.Provider;
const useCheckoutDeliveryContext = () => {
  const ctx = (0, _react.useContext)(checkoutDeliveryContext);
  if (!ctx) {
    throw new Error('useCheckoutDeliveryContext must be used within a CheckoutDeliveryProvider');
  }
  return ctx;
};
exports.useCheckoutDeliveryContext = useCheckoutDeliveryContext;